<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <div class="banner">
                    <div class="row align-items-center justify-content-center">
                        
                        <img src="assets/dmk.png" alt="MyRoots Logo" class="img-circle elevation-2 forImg1" style="opacity: 1.8;"> 
                <h4 class="font-weight-bold forImgTxtNew ml-3">Welcome to MyRoots Student Registration</h4>
                <button type="button" class="close font-weight-bold" (click)="close()">
                    &times;
                </button>
            </div>
            </div>

        </div>
        <div *ngIf="!tableshow" class="d-flex justify-content-center">
            <div class="loader"></div>
        </div>
        <div class="p-6">
            <div class="card-danger">
                <div class="card-body">
                    <form class="register-form" [formGroup]='createmeetingform' (ngSubmit)="postdata(createmeetingform)"
                        autocomplete="off">
                        <div class="form-group row" style="border:1px solid #dfdcdc;background-color:#dfdcdc ; border-radius: 10px;height:offsetHeight;padding:20px 5px;" >
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label>Name<span class="required "> *</span></label>
                                <input pInputText type="text"     (input)="onInputName($event)"
                                class="form-control" formControlName="name"
                                    placeholder="Enter Name ">
                                <div style="color:red;"
                                    *ngIf="(createmeetingform.get('name').touched && createmeetingform.get('name').value=='')">
                                    Please fill the field</div>
                                    <div *ngIf="createmeetingform.get('name')?.hasError('pattern') && createmeetingform.get('name')?.touched" class="text-danger fs-13 mt-1" style="color:red !important;">
                                        Please enter alphabet characters only.
                                      </div>
                            </div>
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label> Father Name<span class="required "> *</span></label>
                                <input pInputText type="text"     (input)="onInputName($event)"
                                class="form-control" formControlName="father_name"
                                    placeholder="Enter Father Name ">
                                <div style="color:red;"
                                    *ngIf="(createmeetingform.get('father_name').touched && createmeetingform.get('father_name').value=='')">
                                    Please fill the field</div>
                                    <div *ngIf="createmeetingform.get('father_name')?.hasError('pattern') && createmeetingform.get('father_name')?.touched" class="text-danger fs-13 mt-1" style="color:red !important;">
                                        Please enter alphabet characters only.
                                      </div>
                                      
                            </div>
                        <!-- </div>


                        <div class="form-group row" > -->
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label>Date of Birth <span class="required">*</span></label>
                                <input type="date" formControlName="DOB" class="form-control"
                                     (keyup)="validateDOB(createmeetingform.get('DOB').value)"  required>
                                <div style="color:red;"
                                    *ngIf="(createmeetingform.get('DOB').touched && createmeetingform.get('DOB').value=='')">
                                    Please fill the field</div>
                                <div style="color:red;" *ngIf="createmeetingform.get('DOB').errors?.['invalidAge']">
                                  Please enter a valid date of birth (age must be at least 15).
                                </div>
                              </div>
                              
                            <div class="col-sm-6">
                                <label>Email<span class="required "> *</span></label>
                                <input type="email" class="form-control" formControlName="email"
                                    placeholder="Enter valid email to get Login credentials" (keyup)="getemail(createmeetingform.get('email').value)"  required>
                                <div style="color:red;"
                                    *ngIf="(createmeetingform.get('email').touched && createmeetingform.get('email').value=='')">
                                    Please fill
                                    the field</div>
                                    <div  class="invalid-msg" *ngIf="test_email=='true'&& createmeetingform.get('email').value !='' && createmeetingform.get('email').status=='VALID'" style="color:red !important;">This email is already exist and please enter new email</div>
                                    <div *ngIf="createmeetingform.get('email')?.hasError('pattern') && createmeetingform.get('email')?.touched" class="text-danger fs-13 mt-1" style="color:red !important;">
                                        Please fill valid Email-id 
                                      </div>
                                <!-- <div  *ngIf="(createmeetingform.get('meeting_time').touched && createmeetingform.get('meeting_time').value=='')"
                                        class="invalid-msg" >Please fill this field</div> -->
                                <!-- <div  class="invalid-msg" *ngIf="createmeetingform.get('meeting_time').untouched" [hidden]='hidden'>Please fill this field</div> -->
                            </div>
                        </div>

                        <div class="form-group row" style="border:1px solid #dfdcdc;
                                                           background-color:#dfdcdc; 
                                                           border-radius: 10px;
                                                           height:offsetHeight;
                                                           padding:20px 5px;">
                            <div class="col-sm-6">
                                <label>WhatsApp Number(User ID) <span class="required "> *</span></label>
                                <input pInputText type="text" class="form-control" formControlName="number"
                                    placeholder="Enter valid whatsApp number to get Login credentials"                                
                                         (input)="onInputNumber($event)" 
                                    (keyup)="getphone(createmeetingform.get('number').value)" required maxlength="10" (keypress)="onKeyPressNumber($event)">
                                <div style="color:red;"
                                    *ngIf="(createmeetingform.get('number').touched && createmeetingform.get('number').value=='')">
                                    Please fill
                                    the field</div>
                                    <div  class="invalid-msg" *ngIf="test_ph=='true' && createmeetingform.get('number').value !='' && createmeetingform.get('number').status=='VALID'" style="color:red !important;">This phone number is already exist</div>
                                    <div *ngIf="createmeetingform.get('number')?.hasError('pattern') && createmeetingform.get('number')?.touched"
                                    class=" text-danger fs-13 mt-1" style="color:red !important;">Please fill valid Mobile Number
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <label>Parents WhatsApp Number<span class="required "> *</span></label>
                                <input pInputText type="text" class="form-control" formControlName="parent_number"
                                    placeholder="Enter Parents WhatsApp Number"
                                    (input)="onInputNumber($event)" 

                                     (keyup)="getlogincheck(createmeetingform.get('parent_number').value)" required maxlength="10" (keypress)="onKeyPressNumber($event)">
                                    <div style="color:red;"
                                    *ngIf="(createmeetingform.get('parent_number').touched && createmeetingform.get('parent_number').value=='')">
                                    Please fill
                                    the field</div>
                                    <div *ngIf="createmeetingform.get('parent_number')?.hasError('pattern') && createmeetingform.get('parent_number')?.touched"
                                    class=" text-danger fs-13 mt-1" style="color:red !important;">Please fill valid Mobile Number
                                </div>
                                <div *ngIf="test_pr=='true' "
                                class="text-danger fs-13 mt-1" style="color:red !important;">
                                Student Number and Parent Number must be different
                              </div>

                                  
                            </div>
                        </div>
                        <div class="form-group row" style="border:1px solid #dfdcdc;
                                                           background-color:#dfdcdc; 
                                                           border-radius: 10px;
                                                           height:offsetHeight;
                                                           padding:20px 5px;"  >
 <div class="col-sm-6">
    <label>District<span class="required ">
            *</span></label><br>
    <select class="form-control" formControlName="district" [(ngModel)]="district" #mydst
        (change)="getChangeToConstituey(mydst.value)">
        <option value="" selected disabled hidden>Select District</option>
        <option *ngFor="let option of district_list" (value)="option">
            {{option}}</option>
    </select>
    <div style="color:red;"
        *ngIf=" createmeetingform.get('district').touched && createmeetingform.get('district').value==''">
        Please fill
        the field</div>
</div>
<div class="col-sm-6">
                                <label>Course/Grade<span class="required ">
                                        *</span></label>
                                <input pInputText type="text" class="form-control" formControlName="grade" (input)="onInputCourse($event)"
                                    placeholder="Enter Course/Grade" required>
                                <div style="color:red;"
                                    *ngIf="(createmeetingform.get('grade').touched && createmeetingform.get('grade').value=='')">
                                    Please fill
                                    the field</div>
                            </div>
                            <div class="col-sm-12">
                                <label>Institution Name<span class="required ">
                                        *</span></label>
                                <input pInputText type="text" class="form-control" formControlName="college_name" (input)="onInputInstitution($event)"
                                    placeholder="Enter Institution Name" required>
                                <div style="color:red;"
                                    *ngIf="(createmeetingform.get('college_name').touched && createmeetingform.get('college_name').value=='')">
                                    Please fill
                                    the field</div>
                            </div>
                        <!-- </div>

                        <div class="form-group row " id="Check1"> -->
                           
                            <!-- <div class="col-sm-6">
                                <label>Photo <span class="required">*</span></label>
                                <input type="file" formControlName="image" id="file" class="form-control" (change)="selectFiles($event)" />
                                <p style="color:black; margin-bottom: unset;">Note: File size should be 60 kb and format jpeg,jpg,png</p>
                                <div style="color:red; "
                                    *ngIf="createmeetingform.get('image').touched && (createmeetingform.get('image').hasError('required') || createmeetingform.get('image').hasError('imageSizeExceeded'))">
                                    Please upload valid image 
                                </div>
                            </div> -->
                            <!-- <div class="col-sm-6">
                                <label>Subjects Coaching Required <span class="required ">
                                        *</span></label>
                                <input pInputText type="text" class="form-control" formControlName="subject"
                                    placeholder="Enter Coaching Required Subjects" required>
                                <div style="color:red;"
                                    *ngIf=" createmeetingform.get('subject').touched && createmeetingform.get('subject').value==''">
                                    Please fill
                                    the field</div>
                            </div> -->

                        </div>

                        <!-- <div class="form-group row">
                            <div class="col-sm-12">
                                <label>Photo <span class="required">*</span></label>
                                <input type="file" formControlName="image" id="file" class="form-control" (change)="selectFiles($event)" />
                                <p style="color:black; margin-bottom: unset;">Note: File size should be 60 kb and format jpeg,jpg,png</p>
                                <div style="color:red; "
                                    *ngIf="createmeetingform.get('image').touched && (createmeetingform.get('image').hasError('required') || createmeetingform.get('image').hasError('imageSizeExceeded'))">
                                    Please upload valid image 
                                </div>
                            </div>
                        </div> -->
                        
                        <div class="form-group row" style="border:1px solid #dfdcdc;background-color:#dfdcdc ; border-radius: 10px;
height:offsetHeight;padding:20px 5px;">
<div class="col-sm-6">
                                <label class="form-label">Password<a style="color:red"> *</a></label>
                                <div class="input-group">
                                    <input type="{{ hidePassword ? 'password' : 'text' }}" class="form-control" formControlName="password"
                                        id="password" placeholder="Enter Password"  />
                                        <div class="input-group-append" style="background-color: white;border-radius: 5px;">
                                            <div class="input-group-text" (click)="togglePasswordVisibility()">
                                                <img src="assets/eye.png" alt="Eye Icon" style="height:9px;mix-blend-mode: multiply;">
                                            </div></div>
                                           
                                        </div>
                                        <div *ngIf="createmeetingform.get('password').touched">
                                            <div *ngIf="createmeetingform.get('password').hasError('required')" style="color: red;">
                                                Please fill the field
                                            </div>
                                            <div *ngIf="createmeetingform.get('password').hasError('passwordStrength')" style="color: red;">
                                              Password must be at least 8 characters long, with at least 1 uppercase letter, 1 lowercase letter, and 1 special character.
                                            </div>
                                          </div>

                              </div>
                              <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Confirm Password<span style="color: red"> *</span></label>
                                <div class="input-group">
                                    <input type="{{ hidepassword1 ? 'password' : 'text' }}" class="form-control" formControlName="confirm_password"
                                        id="confirm_password" placeholder="Enter Confirm Password" (blur)="handleBlurChange()" />
                                        <div class="input-group-append" style="background-color: white;border-radius: 5px;">
                                            <div class="input-group-text" (click)="togglePassword()">
                                                <img src="assets/eye.png" alt="Eye Icon" style="height:9px;mix-blend-mode: multiply;">
                                            </div></div>
                                           
                                        </div>
                                <span *ngIf="createmeetingform.hasError('passwordMismatch') && (createmeetingform.dirty || createmeetingform.touched)" style="color: red">Password Mismatch</span>
                            </div>
                            
                        </div>
                        <br />
                        <div class="form-group row">
                            <div class="col-sm-10">
                              <label>CAPTCHA<span class="required"> *</span></label>
                              <re-captcha class="g-recaptcha"
                              siteKey="6LfgWy4qAAAAAFA_fFnEtWlW0TnhfH0p73y86j_5"

                                (resolved)="onCaptchaResolved($event)" style="transform:scale(0.77);-webkit-transform:scale(0.77);transform-origin:0 0;-webkit-transform-origin:0 0;">
                              </re-captcha>
                               <!-- <re-captcha
                class="g-recaptcha"
                  siteKey="6LfUyTwqAAAAAJMGRDb38ec7oLRj_gjRUPNF_8eI"
                  (resolved)="onCaptchaResolved($event)">
                
                </re-captcha> -->
                              <div style="color:red;" *ngIf="captchaError">Please complete the CAPTCHA</div>
                            </div>
                          </div>
                        <div class="d-flex justify-content-center">
                            <div style="width:200px">
                                <button class="btn btn-primary btn btn-block" [disabled]="isFormDisabled()">Submit</button>
                            </div>
                        </div>

                    </form>


                </div>
            </div>
        </div>


        <div class="modal fade" id="myModal">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">

                </div>
            </div>
        </div>



        <div class="modal fade" id="showCM">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="card-danger">
                        <div class="card-header">
                            <h3 class="card-title" id="card_title"></h3>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="card-body">
                            <form class="register-form" [formGroup]='editmeetingform'
                                (ngSubmit)="updatedata(editmeetingform,CM_id)" autocomplete="off">
                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Name</label><span class="required "> *</span>
                                        <input readonly pInputText type="text" class="form-control" [value]="CM_name" formControlName="name" placeholder="Enter Name / பெயர்">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label> Father Name </label><span class="required "> *</span>
                                        <input readonly pInputText type="text" class="form-control" [value]="CM_father_name" formControlName="name"
                                            placeholder="Enter  Father Name /தந்தை பெயர்">

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Date of Birth</label><span class="required "> *</span>
                                        <input readonly pInputText type="date" class="form-control" [value]="CM_DOB" formControlName="name"
                                            placeholder="Enter Date of Birth / பிறந்த நாள்">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Email <span class="required "> *</span></label>
                                        <input readonly pInputText type="email" class="form-control" [value]="CM_email" formControlName="name"
                                            placeholder="Enter Email / மின்னஞ்சல்">

                                    </div>
                                </div>

                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>WhatsApp Number <span class="required "> *</span></label>
                                        <input readonly pInputText type="text" class="form-control" [value]="CM_number" formControlName="name"
                                            placeholder="Enter Date of Birth / பிறந்த நாள்">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Parents WhatsApp Number <span class="required "> *</span></label>
                                        <input readonly pInputText type="email" class="form-control" [value]="CM_parent_number" formControlName="name"
                                            placeholder="Enter Parents WhatsApp Number/பெற்றோர் வாட்ஸ்அப் எண்">

                                    </div>
                                </div>


                                    <div class="form-group row" *ngIf="!editfield">
                                        <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>School Grade<span class="required ">*</span></label>
                                            <input readonly pInputText type="text" class="form-control" [value]="CM_grade"  formControlName="grade" placeholder="Enter School Grade/கல்லூரி தரம்"
                                                required>

                                        </div>
                                        <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>School Name<span class="required ">
                                                *</span></label>
                                            <input readonly pInputText type="text" class="form-control" [value]="CM_college_name" formControlName="college_name"
                                                placeholder="Enter School Name/கல்லூரியின் பெயர்">
                                        </div>
                                    </div>
                                    <div class="form-group row" *ngIf="!editfield">
                                        <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>District <span class="required">
                                                *</span></label><br>
                                        <input readonly [value]="CM_district" pInputText type="text" class="form-control" formControlName="district" placeholder="Enter District / மாவட்டம்"
                                            required>
                                        </div>
                                        <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Subjects Coaching Required <span class="required ">
                                                *</span></label>
                                            <input readonly pInputText type="text" class="form-control" [value]="CM_subject"
                                                formControlName="subject" placeholder="Enter Subjects Coaching Required / பாடங்கள் பயிற்சி தேவை">
                                        </div>
                                    </div>
                                    <div class="row">
                                    <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="CM_image !=='' && !editfield">
                                        <label>Image <span class="required "> *</span></label>
                                        <img src="http://myroots.redmindtechnologies.com/api/{{CM_image}}"
                                            style="width:100px;height:100px;display:block" />

                                    </div>
                                    </div>
                                                            <div class="form-group row" *ngIf="editfield">
                                                                <div class="col-sm-6 mb-3 mb-sm-0">
                                                                    <label>Name </label><span class="required "> *</span>
                                                                    <input  pInputText type="text" class="form-control" [value]="CM_name" formControlName="name"
                                                                        placeholder="Enter Name / பெயர்">

                                                                </div>
                                                                <div class="col-sm-6 mb-3 mb-sm-0">
                                                                    <label> Father Name </label><span class="required "> *</span>
                                                                    <input  pInputText type="text" class="form-control" [value]="CM_father_name" formControlName="father_name"
                                                                        placeholder="Enter  Father Name /தந்தை பெயர்">

                                                                </div>
                                                            </div>
                                                            <div class="form-group row" *ngIf="editfield">
                                                                <div class="col-sm-6 mb-3 mb-sm-0">
                                                                    <label>Date of Birth </label><span class="required "> *</span>
                                                                    <input  pInputText type="date" class="form-control" [value]="CM_DOB" formControlName="DOB"
                                                                        placeholder="Enter Date of Birth / பிறந்த நாள்">

                                                                </div>
                                                                <div class="col-sm-6 mb-3 mb-sm-0">
                                                                    <label>Email <span class="required "> *</span></label>
                                                                    <input  pInputText type="email" class="form-control" [value]="CM_email" formControlName="email"
                                                                        placeholder="Enter Email / மின்னஞ்சல்">

                                                                </div>
                                                            </div>

                                                            <div class="form-group row" *ngIf="editfield">
                                                                <div class="col-sm-6 mb-3 mb-sm-0">
                                                                    <label>WhatsApp Number<span class="required "> *</span></label>
                                                                    <input  pInputText type="text" class="form-control" [value]="CM_number" formControlName="number"
                                                                        placeholder="Enter Date of Birth / பிறந்த நாள்">

                                                                </div>
                                                                <div class="col-sm-6 mb-3 mb-sm-0">
                                                                    <label>Parents WhatsApp Number<span class="required "> *</span></label>
                                                                    <input  pInputText type="email" class="form-control" [value]="CM_parent_number" formControlName="parent_number"
                                                                        placeholder="Enter Parents WhatsApp Number/பெற்றோர் வாட்ஸ்அப் எண்">

                                                                </div>
                                                            </div>


                                                            <div class="form-group row" *ngIf="editfield">
                                                                <div class="col-sm-6 mb-3 mb-sm-0">
                                                                    <label>School Grade<span class="required ">*</span></label>
                                                                    <input  pInputText type="text" class="form-control" [value]="CM_grade" formControlName="grade"
                                                                        placeholder="Enter School Grade/கல்லூரி தரம்" required>

                                                                </div>
                                                                <div class="col-sm-6 mb-3 mb-sm-0">
                                                                    <label>School Name<span class="required ">
                                                                            *</span></label>
                                                                    <input  pInputText type="text" class="form-control" [value]="CM_college_name"
                                                                        formControlName="college_name" placeholder="Enter School Name/கல்லூரியின் பெயர்">
                                                                </div>
                                                            </div>
                                                            <div class="form-group row" *ngIf="editfield">
                                                                <div class="col-sm-6 mb-3 mb-sm-0">
                                                                    <label>District<span class="required ">
                                                                            *</span></label><br>
                                                                    <select class="form-control" formControlName="district" [(ngModel)]="district" #mydst
                                                                        (change)="getChangeToConstituey(mydst.value)">
                                                                        <option value="" selected disabled hidden>Select District</option>
                                                                        <option *ngFor="let option of district_list" [ngValue]="option">
                                                                            {{option}}</option>
                                                                    </select>

                                                                </div>
                                                                <div class="col-sm-6 mb-3 mb-sm-0">
                                                                    <label>Subjects Coaching Required <span class="required ">
                                                                            *</span></label>
                                                                    <input  pInputText type="text" class="form-control" [value]="CM_subject" formControlName="subject"
                                                                        placeholder="Enter Subjects Coaching Required / பாடங்கள் பயிற்சி தேவை">
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="CM_image !==''&& editfield">
                                                                    <label>Image <span class="required "> *</span></label>
                                                                    <img src="http://myroots.redmindtechnologies.com/api/{{CM_image}}"
                                                                        style="width:100px;height:100px;display:block" />

                                                                </div>
                                                                <div class="col-md-6" *ngIf="editfield">
                                                                    <label>Photo<span class="required">*</span></label>
                                                                    <input type="file" class="form-control" formControlName="image" (change)="selectFiles($event)" />
                                                                </div>
                                                            </div>



                                <div *ngIf="editfield" class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-danger btn btn-block">Update </button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <!-- <footer class="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top"> -->
                <!-- <div class="col-md-4 d-flex align-items-center">
                    <a href="/" class="mb-3 me-2 mb-md-0 text-muted text-decoration-none lh-1">
                        <svg class="bi" width="30" height="24">
                            <use xlink:href="#bootstrap" />
                        </svg>
                    </a>
                    <span class="mb-3 mb-md-0 text-muted">&copy; {{footerdate}} MyRoots   </span>
                </div> -->

                <!-- <ul class="nav col-md-4 justify-content-end list-unstyled d-flex">
                    <li class="ms-3"><a class="text-muted" href="#"><svg class="bi" width="24" height="24">
                                <use xlink:href="#twitter" />
                            </svg></a></li>
                    <li class="ms-3"><a class="text-muted" href="#" ><svg xmlns="http://www.w3.org/2000/svg" style="margin-top:3px;" width="25" height="25" viewBox="0 0 256 256">
                        <g fill="none">
                            <rect width="256" height="256" fill="url(#skillIconsInstagram0)" rx="60" />
                            <rect width="256" height="256" fill="url(#skillIconsInstagram1)" rx="60" />
                            <path fill="#fff"
                                d="M128.009 28c-27.158 0-30.567.119-41.233.604c-10.646.488-17.913 2.173-24.271 4.646c-6.578 2.554-12.157 5.971-17.715 11.531c-5.563 5.559-8.98 11.138-11.542 17.713c-2.48 6.36-4.167 13.63-4.646 24.271c-.477 10.667-.602 14.077-.602 41.236s.12 30.557.604 41.223c.49 10.646 2.175 17.913 4.646 24.271c2.556 6.578 5.973 12.157 11.533 17.715c5.557 5.563 11.136 8.988 17.709 11.542c6.363 2.473 13.631 4.158 24.275 4.646c10.667.485 14.073.604 41.23.604c27.161 0 30.559-.119 41.225-.604c10.646-.488 17.921-2.173 24.284-4.646c6.575-2.554 12.146-5.979 17.702-11.542c5.563-5.558 8.979-11.137 11.542-17.712c2.458-6.361 4.146-13.63 4.646-24.272c.479-10.666.604-14.066.604-41.225s-.125-30.567-.604-41.234c-.5-10.646-2.188-17.912-4.646-24.27c-2.563-6.578-5.979-12.157-11.542-17.716c-5.562-5.562-11.125-8.979-17.708-11.53c-6.375-2.474-13.646-4.16-24.292-4.647c-10.667-.485-14.063-.604-41.23-.604h.031Zm-8.971 18.021c2.663-.004 5.634 0 8.971 0c26.701 0 29.865.096 40.409.575c9.75.446 15.042 2.075 18.567 3.444c4.667 1.812 7.994 3.979 11.492 7.48c3.5 3.5 5.666 6.833 7.483 11.5c1.369 3.52 3 8.812 3.444 18.562c.479 10.542.583 13.708.583 40.396c0 26.688-.104 29.855-.583 40.396c-.446 9.75-2.075 15.042-3.444 18.563c-1.812 4.667-3.983 7.99-7.483 11.488c-3.5 3.5-6.823 5.666-11.492 7.479c-3.521 1.375-8.817 3-18.567 3.446c-10.542.479-13.708.583-40.409.583c-26.702 0-29.867-.104-40.408-.583c-9.75-.45-15.042-2.079-18.57-3.448c-4.666-1.813-8-3.979-11.5-7.479s-5.666-6.825-7.483-11.494c-1.369-3.521-3-8.813-3.444-18.563c-.479-10.542-.575-13.708-.575-40.413c0-26.704.096-29.854.575-40.396c.446-9.75 2.075-15.042 3.444-18.567c1.813-4.667 3.983-8 7.484-11.5c3.5-3.5 6.833-5.667 11.5-7.483c3.525-1.375 8.819-3 18.569-3.448c9.225-.417 12.8-.542 31.437-.563v.025Zm62.351 16.604c-6.625 0-12 5.37-12 11.996c0 6.625 5.375 12 12 12s12-5.375 12-12s-5.375-12-12-12v.004Zm-53.38 14.021c-28.36 0-51.354 22.994-51.354 51.355c0 28.361 22.994 51.344 51.354 51.344c28.361 0 51.347-22.983 51.347-51.344c0-28.36-22.988-51.355-51.349-51.355h.002Zm0 18.021c18.409 0 33.334 14.923 33.334 33.334c0 18.409-14.925 33.334-33.334 33.334c-18.41 0-33.333-14.925-33.333-33.334c0-18.411 14.923-33.334 33.333-33.334Z" />
                            <defs>
                                <radialGradient id="skillIconsInstagram0" cx="0" cy="0" r="1"
                                    gradientTransform="matrix(0 -253.715 235.975 0 68 275.717)" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#FD5" />
                                    <stop offset=".1" stop-color="#FD5" />
                                    <stop offset=".5" stop-color="#FF543E" />
                                    <stop offset="1" stop-color="#C837AB" />
                                </radialGradient>
                                <radialGradient id="skillIconsInstagram1" cx="0" cy="0" r="1"
                                    gradientTransform="matrix(22.25952 111.2061 -458.39518 91.75449 -42.881 18.441)"
                                    gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#3771C8" />
                                    <stop offset=".128" stop-color="#3771C8" />
                                    <stop offset="1" stop-color="#60F" stop-opacity="0" />
                                </radialGradient>
                            </defs>
                        </g>
                    </svg>

                        </a></li>
                    <li class="ms-3"><a class="text-muted" href="#"><svg  xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 72 72">
                        <path fill="#61b2e4" d="M57 12H15a4 4 0 0 0-4 4v42a4 4 0 0 0 4 4h42a4 4 0 0 0 4-4V16a4 4 0 0 0-4-4Z" />
                        <path fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="2" d="M36.935 62.009h9.5" />
                        <path fill="#fff"
                            d="M48.5 26.844h4.688v-7.031c-3.126 0-15.626-3.125-15.626 10.156v4.687h-6.25v7.813h6.25v18.564l7.813-.014V42.47h7.031l.781-7.813h-7.812V29.97c0-3.125 2.344-3.125 3.125-3.125Z" />
                        <g fill="none" stroke="#000" stroke-width="2">
                            <path stroke-miterlimit="10"
                                d="M45.619 62h12.155A3.226 3.226 0 0 0 61 58.774V15.226A3.226 3.226 0 0 0 57.774 12H14.226A3.226 3.226 0 0 0 11 15.226v43.548A3.226 3.226 0 0 0 14.226 62h23.476" />
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M45.618 62V42.208h7.125l.792-7.917h-7.917v-4.75c0-3.167 2.375-3.167 3.167-3.167h4.75V19.25c-3.2-.324-15.834-3.166-15.834 10.292v4.75h-6.333v7.917h6.333V62" />
                        </g>
                    </svg></a></li>
                </ul> -->
            <!-- </footer> -->

           
            
              </div>
                <div class="footer">
                  <div class="text-center p-3">
                    <p>Copyright © MyRoots. Developed by <a href="https://redmindtechnologies.com/" target="_blank">RedMind Technologies</a> {{footerdate}}</p>
                  </div>
               
            
        </div>
